import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/Account`;
const prtectedApiUrl = process.env.REACT_APP_Protected_API_URL;
function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  });
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}
//tes
const ApiAuth = {
  login: (data) => {
    try {
      const url = `${prtectedApiUrl}${baseServiceUrl}/requestAuthenticateByPhoneAsync`;
      var result = ServiceApi.post(url, data);
    } catch (error) {
      alert(error.response.data.message);
    }
    return result;
  },
  verifyMobile: (data) => {
    const url = `${prtectedApiUrl}${baseServiceUrl}/authenticateByPhone`;
    var result = ServiceApi.post(url, data);

    return result;
  },
  logout: (params) => {
    const url =
      `${prtectedApiUrl}${baseServiceUrl}/logout` + paramsToStringList(params);

    return ServiceApi.post(url);
  },
  register: (data) => {
    const url = `${baseServiceUrl}/register`;
    return ServiceApi.post(url, data);
  },
  updateUserSite: (data) => {
    const url = `${prtectedApiUrl}${baseServiceUrl}/updateUserSite`;
    return ServiceApi.post(url, data);
  },
  isCaptchaRequired: (data) => {
    const url = `${prtectedApiUrl}${baseServiceUrl}/isCaptchaRequired`;
    return ServiceApi.get(url);
  },
};

export default ApiAuth;
